import Http from '@/utils/request';

export default {
  getMachineCode: (params) => Http.get('/api/v1/offLicense/getMachineCode', { params }),
  getAuthList: (params) => Http.get('/api/v1/offLicense/getOwnerInfo',{params}),
  exportMachineCode: (params) => Http.get('/api/v1/offLicense/download', { params , responseType: "arraybuffer"}),
};
